module.exports = __webpack_public_path__ + "static/media/filters.9f81b945.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Candidate/InsidersList/assets/filters.svg
// module id = 1730
// module chunks = 0